define('TescoMobile_BoPo/js/view/monthly-payment-step-mixin',['jquery', 'TescoMobile_Checkout/js/model/payment-information', 'Magento_Checkout/js/model/step-navigator'], function ($, paymentInformation, stepNavigator) {
  'use strict';

  var mixin = {
    initialize: function () {
      this._super();
      this.addCallbackToMapping('CO_500', (paymentComponent, response) => {
        paymentInformation.response(response);
        stepNavigator.next();
      });
    }
  };
  return function (target) {
    return target.extend(mixin);
  };
});

